import axios from "axios";

const BASE_URL = process.env.REACT_APP_LOGINURL || "http://localhost:3005/api/";
const B_URL = BASE_URL.replace(/\/$/, '') + '/';

/**
 * Save Driver Location
 */
const saveDriverLocation = (data) => {
  const headers = {
    'Content-Type': 'application/json',
    'token': localStorage.getItem("session-id")
  };
  var payload = {
    functionName: "SaveDriverLocation",
    postData: data
  };
  return axios.post(B_URL + 'DriverLocationRoutes/SaveDriverLocation', payload, { headers });
};

/**
 * Get Driver Location
 */
const getDriverLocation = (data) => {
  const headers = {
    'Content-Type': 'application/json',
    'token': localStorage.getItem("session-id")
  };
  var payload = {
    functionName: "GetDriverLocation",
    postData: data
  };
  return axios.post(B_URL + 'DriverLocationRoutes/GetDriverLocation', payload, { headers });
};

/**
 * Get Active Drivers Locations (for Admin Dashboard)
 */
const getActiveDriversLocations = (data = {}) => {
  const headers = {
    'Content-Type': 'application/json',
    'token': localStorage.getItem("session-id")
  };
  var payload = {
    functionName: "GetActiveDriversLocations",
    postData: data
  };
  return axios.post(B_URL + 'DriverLocationRoutes/GetActiveDriversLocations', payload, { headers });
};

const DriverLocationService = {
  saveDriverLocation,
  getDriverLocation,
  getActiveDriversLocations
};

export default DriverLocationService;

